module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDMyIDMyIj4KICAgIDxwYXRoIGQ9Ik0yLjY2NyA3LjAyN2wxLjcwNy0xLjY5MyAyMi4yOTMgMjIuMjkzLTEuNjkzIDEuNzA3LTQtNGgtMTEuNjR2NGwtNS4zMzMtNS4zMzMgNS4zMzMtNS4zMzN2NGg4Ljk3M2wtOC45NzMtOC45NzN2MC45NzNoLTIuNjY3di0zLjY0bC00LTR6TTIyLjY2NyAxNy4zMzNoMi42Njd2NS41NzNsLTIuNjY3LTIuNjY3di0yLjkwN3pNMjIuNjY3IDYuNjY3di00bDUuMzMzIDUuMzMzLTUuMzMzIDUuMzMzdi00aC0xMC45MDdsLTIuNjY3LTIuNjY3aDEzLjU3M3oiPjwvcGF0aD4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/components/aplayer/assets/no-repeat.svg
// module id = fuqP
// module chunks = 30